import { ProfessionalsPage } from "./ProfessionalsPage";
export default ProfessionalsPage;
